import { Box } from '@mui/material';
import { RealAppWrapper } from 'components/app-wrapper/app-wrapper.component';
import AppRoutes2 from 'pages/app-routes-2.component';

const App = () => {
  return (
    <RealAppWrapper>
      <Box
        sx={{
          minWidth: '350px',
          height: '100vh',
        }}
      >
        <AppRoutes2 />
      </Box>
    </RealAppWrapper>
  );
};

export default App;
